
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button-message.vue";
  import AddResourceInformationModal from "@/components/common/AddResourceInformationNew.vue";

  @Component({
  components: {
    UiButton,
    AddResourceInformationModal,
  }
  })
  export default class EmptyResourceInformationPlaceholder extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;
    @Prop({ type: String, default: "" }) readonly description!: string;
    @Prop({ type: String, default: "" }) readonly desc!: string;
    @Prop({ type: String, default: "" }) readonly subtitle!: string;
    @Prop({ type: String, required: true }) readonly contractorId!: string; 
    @Prop({ type: String, required: true }) readonly currentUserId!: string; 
    @Prop({ type: Boolean, required: false, default: true}) readonly isAccessGranted!: boolean;

    modalShown: boolean = false;
    
    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }
    
    refreshPage(): void {
      this.$emit('refresh')
    }
  }
